export default __webpack_public_path__ + "static/media/PF.7e15ea09.svg";